import * as firebase from "firebase";
import mem from "mem";

export const parseDocSnapshot = (docSnapshot) => ({
  id: docSnapshot.id,
  ref: docSnapshot.ref,
  ...docSnapshot.data(),
});

export const getFile = mem(loc => firebase.storage().ref(loc).getDownloadURL());
